
import React, { useEffect } from "react";
import PropTypes from "prop-types";
import SelectInput from "../common/formfields/SelectInput"
import CheckboxInput from "../common/formfields/CheckboxInput"

const SettingsSiteForm = ({
    settings,
    onSave,
    onChange,
    processing = false,
    errors = {}
}) => {
    return (
        <form className="col-md-6 mt-md-5">
            <h2>Site Settings</h2>
            <hr />
            {errors.onSiteSave && (
                <div className="alert alert-danger" role="alert">
                    {errors.onSiteSave}
                </div>
            )}
            <h3>Privacy</h3>
            <p>
                You have the option to review follow requests in the rider network.
                This allows you to choose who follows you. A following user will be able
                to see what routes you create and anything that you post on your timeline. 
            </p>
            <CheckboxInput
                name="approveFollowers"
                label="Approve Follow Requests"
                checked={settings.approveFollowers}
                onChange={onChange}
                error={errors.approveFollowers}
            />
            <h3>Measurement Units</h3>
            <p>
                Select how you would like distance and elevation to be displayed accross the site. 
                Choosing Metric will display distance in kilometres and elevation in metres whereas 
                choosing Statute will show distance in miles and elevation in feet.
            </p>
            <SelectInput
                name="preferredMeasurementUnits"
                label="Measurements"
                value={settings.preferredMeasurementUnits || ""}
                defaultOption="Select Units"
                options={[
                    {
                        value: "0", 
                        text: "Metric"
                    }, 
                    {
                        value: "1", 
                        text: "Statue"
                    }
                ]}
                onChange={onChange}
                error={errors.preferredMeasurementUnits}
            />
            <h3>Notifications</h3>
            <p>
                The following options control the email notifications that you receive
            </p>  
            <CheckboxInput
                name="subscribedRideBlogsNotification"
                label="Comment Notifications"
                checked={settings.subscribedRideBlogsNotification}
                onChange={onChange}
                error={errors.subscribedRideBlogsNotification}
            />

            <CheckboxInput
                name="subscribedMarketingNotification"
                label="General Marketing including competitions and special offers"
                checked={settings.subscribedMarketingNotification}
                onChange={onChange}
                error={errors.subscribedMarketingNotification}
            />


            <button type="submit" onClick={onSave} disabled={processing} className="btn btn-primary float-right">
                {processing ? "Processing..." : "Save Changes"}
            </button>
        </form>
    );
}

SettingsSiteForm.propTypes = {
    settings: PropTypes.object.isRequired,
    errors: PropTypes.object,
    onSave: PropTypes.func.isRequired,
    onChange: PropTypes.func.isRequired,
    processing: PropTypes.bool
}

export default SettingsSiteForm;


// WEBPACK FOOTER //
// ./src/components/user/SettingsSiteForm.js